<a
  class="va-nav-item"
  [routerLink]="[url]"
  [queryParams]="queryParams"
  [ngClass]="{ selected: selected }"
  routerLinkActive="active"
  [routerLinkActiveOptions]="{ exact: activeExactRoute }"
  >
  <button class="nav-button" mat-button>
    @if (icon && !isSvg) {
      <mat-icon>{{ icon }}</mat-icon>
    }
    @if (icon && isSvg) {
      <mat-icon [svgIcon]="icon" />
    }
    <span class="truncate">{{ label }}</span>
  </button>
</a>
